"use client";

import { useState, useEffect } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card } from "@/components/ui/card";
const clients = [{
  id: 1,
  name: "TechCorp",
  logo: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/Aspirations.png",
  excerpt: "Both candidates interviewed very well and each have some wonderful qualities that would suit our Residents person centered needs in the home - we want them both but can only offer the position to one at this time, a real dilemma! "
}, {
  id: 2,
  name: "Innovate Ltd",
  logo: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/christian-care-web.png",
  excerpt: "I think Sarah is an outstanding candidate - a true specialist! Well done, great find! "
}, {
  id: 3,
  name: "Global Industries",
  logo: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/Fremantle-Trust.jpg",
  excerpt: "Our new starters are getting on so well - I have only heard good things- thank you! "
}, {
  id: 4,
  name: "NextGen Solutions",
  logo: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/Autograph.png",
  excerpt: "Emma was really impressive 😊 I think we are now in a position to offer the job!"
}, {
  id: 5,
  name: "Future Enterprises",
  logo: "https://optimum-imp.10web.cloud/wp-content/uploads/2025/11/Freeways.png",
  excerpt: "Well done on these candidates they were all great! "
}];
export default function SuccessStories() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground text-center mb-12">
          Success Stories
        </h2>

        <Carousel setApi={setApi} opts={{
        align: "center",
        loop: true,
        dragFree: true,
        duration: 35
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent className="-ml-4">
            {clients.map((client, i) => <CarouselItem key={client.id} data-index={i} className="pl-4 basis-full md:basis-1/2 lg:basis-1/3">
                <Card className={`glass-effect p-8 flex items-center justify-center min-h-[200px] transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${i === current ? "scale-105 translate-y-[-6px] shadow-strong" : "scale-100 translate-y-0"}`}>
                  <img src={client.logo} alt={`${client.name} logo`} className="max-w-[180px] max-h-[80px] object-contain" />
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="!bg-[#d7df23] hover:!bg-[#c4cc1f]" />
          <CarouselNext className="!bg-[#d7df23] hover:!bg-[#c4cc1f]" />
        </Carousel>

        <div className="mt-12 text-center max-w-2xl mx-auto min-h-[80px] flex items-center justify-center">
          <p key={current} className="text-foreground-muted-light text-base md:text-lg leading-relaxed animate-fade-in-up">
            {clients[current]?.excerpt || ""}
          </p>
        </div>
      </div>
    </section>;
}